import { CurrPlayer } from './types';

export function createCurrPlayer(
	color: string,
	playerId: number,
	gameId: string,
	pname: string = ''
): CurrPlayer {
	return {
		color,
		playerId,
		gameId,
		pname,
	};
}
